import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { Navigation } from "./component/navigation";
import { Home } from "./component/home";
import Footer from "./component/footer";
import JsonData from "./data/data.json";
import NotFound from "./component/pageNotFound";
import { Enterprise } from "./component/Enterprise";
// import { PyTrade } from "./component/Pytrade";
import { AboutUs } from "./component/AboutUs";
import {CareersPage} from "./component/Careers";
import { UseCasesPage } from "./component/UseCases";
import TermsAndConditions from "./component/terms-and-conditions";
import PrivacyPolicy from "./component/privacy-policy";
import ScrollSmootherLayout from "./component/ui/scroll-smoother-layout";
import SEO from "./seo/SEO";
import { SEO_PAGES } from "./seo/seoConfig";
import { ForgePage } from "./component/Forge";
import { SessionsPage } from "./component/Sessions";
import ScrollToTop from "./component/ui/scroll-to-top";


const App = () => {
  const [landingPageData, setLandingPageData] = useState({});
  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  return (
    <Router>
      <ScrollToTop />
      <div className="overflow-x-hidden min-w-0 w-full">
      <Navigation />
        <Routes>
          <Route path="/" element={<LandingPage data={landingPageData} />} />
          <Route path="/enterprise" element={<Enterprise data={landingPageData} />} />
          {/* <Route path="/pytrade" element={<PyTrade data={landingPageData} />} /> */}
          <Route path="/about-us" element={<AboutUs data={landingPageData} />} />
          <Route path="/use-cases" element={<UseCasesPage />} />
          <Route path="/careers" element={<CareersPage data={landingPageData} />} />
          <Route path="/forge" element={<ForgePage />} />
          <Route path="/sessions" element={<SessionsPage />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions data={landingPageData} />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy data={landingPageData} />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
    </Router>
  );
};

const LandingPage = () => {
  const seo = SEO_PAGES.home;
  return (
    <>
      <SEO {...seo} />
      <ScrollSmootherLayout>
        <Home />
        <Footer />
      </ScrollSmootherLayout>
    </>
  );
};

export default App;
